const ArtworkCard = ({ id, src, openModal, title, media, dimensions, isLargeSize }) => {
    return (
        <div className={`artwork-card${isLargeSize ? ' large' : ''}`}>
            <img
                className="artwork-card-image"
                src={src}
                alt={`img-${id}`}
                onClick={() => openModal(src, title, dimensions, media)}
                style={{ cursor: 'pointer' }}
            />
            <div className="artwork-card-title-wrapper">


                <div className="artwork-card-title">
                    <p className="prominate">{title}</p>
                    <p>{dimensions}</p>
                </div>
            </div>
        </div>

    );
};

export default ArtworkCard;